import React, { useEffect, useState } from 'react';
import { dashboardAPI } from '../services/api';
import { DashboardOverview } from '../types';

const Dashboard: React.FC = () => {
  const [data, setData] = useState<DashboardOverview | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const overview = await dashboardAPI.getOverview();
      setData(overview);
    } catch (error) {
      console.error('Failed to load dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '40px' }}>Загрузка...</div>;
  if (!data) return <div style={{ textAlign: 'center', padding: '40px' }}>Нет данных</div>;

  return (
    <div>
      <h1>📊 Главная панель</h1>
        
        {/* Quick stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '30px' }}>
        <div style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textAlign: 'center' }}>
          <h3>💰 Баланс</h3>
          <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#16a34a' }}>
            {new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(data.summary.finances.balance)}
          </p>
          <p style={{ fontSize: '14px', color: '#666' }}>
            Изменение: {data.summary.finances.monthlyChange > 0 ? '+' : ''}
            {new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(data.summary.finances.monthlyChange)}
          </p>
        </div>

        <div style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textAlign: 'center' }}>
          <h3>🏥 Здоровье</h3>
          <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#3b82f6' }}>
            ИМТ: {data.summary.health.bmi.toFixed(1)}
          </p>
          <p style={{ fontSize: '14px', color: '#666' }}>
            Шагов: {data.summary.health.stepsProgress.toFixed(0)}%
          </p>
        </div>

        <div style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textAlign: 'center' }}>
          <h3>👨‍👩‍👧‍👦 Семья</h3>
          <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#8b5cf6' }}>
            {data.summary.family.membersCount} чел.
          </p>
          {data.summary.family.nearestEvent ? (
            <div style={{ marginTop: '10px' }}>
              <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#2d3748', margin: '5px 0' }}>
                {data.summary.family.nearestEvent.title}
              </p>
              <p style={{ fontSize: '14px', color: '#888' }}>
                📅 {new Date(data.summary.family.nearestEvent.date).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })}
              </p>
            </div>
          ) : (
            <p style={{ fontSize: '14px', color: '#666' }}>
              События: {data.summary.family.upcomingEvents}
            </p>
          )}
        </div>

        <div style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textAlign: 'center' }}>
          <h3>🎯 Цели</h3>
          <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#f59e0b' }}>
            ✓ {data.summary.goals.completed} ✗ {data.summary.goals.active}
          </p>
          <p style={{ fontSize: '14px', color: '#666' }}>
            Всего: {data.summary.goals.total}
          </p>
        </div>
      </div>
    </div>
  );
};


export default Dashboard;
